import actionTypes from "utils/redux/actions/actionTypes";

const initialState = {
    chatList: [],
    isLoading: false,
    hasError: false,
    errorMessage: "",
    filterOptions: [],
    filterOptionsLoading: false,
    filterOptionsError: false,
    filterOptionsErrorMessage: "",
};
export function chatReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SELECT_CHAT_LIST_SUCCESS:
            return {
                ...state,
                chatList: action.payload
            };

        case actionTypes.SELECT_CHAT_LIST_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            };

        case actionTypes.SELECT_CHAT_LIST_ERROR:
            return {
                ...state,
                hasError: action.hasError,
                errorMessage: action.errorMessage
            };

        case actionTypes.CHAT_MASTER_UPDATE_PREV_TEXT:

            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                newList[index].lastWrittenMessage = action.newText;
                // Son mesaj tarih ve saatini güncelle
                if (action.messageDate) {
                    newList[index].lastMessageDate = action.messageDate;
                }
                if (action.messageTime) {
                    newList[index].lastMessageTime = action.messageTime;
                }
                // Eğer aktif sohbet değilse unread artır
                if (action.activeNumber !== action.customerNumber) {
                    newList[index].unreadMessageCount = newList[index].unreadMessageCount + 1;
                }
                
                // Eğer moveToTop true ise, öğeyi listenin başına taşı
                if (action.moveToTop) {
                    const item = newList[index];
                    newList.splice(index, 1);
                    newList.unshift(item);
                }
            }

            return {
                ...state,
                chatList: newList
            };
        case actionTypes.RESET_UNREAD_COUNT:

            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                newList[index].unreadMessageCount = 0;
            }

            return {
                ...state,
                chatList: newList
            };
        case actionTypes.ON_CHAT_LISTENER:
            var data = action.payload;
            var destination = data.destination;

            var newList = JSON.parse(JSON.stringify(state.chatList));
            var numberIndex = newList.findIndex(w => w.customerNumber == destination);

            if (numberIndex == -1) {
                var chatObj = {
                    customerId: -1,
                    customerImage: "",
                    customerName: destination,
                    firmId: -1,
                    lastMessageDate: data.messageDate || "",
                    lastMessageTime: data.messageTime || "",
                    lastWrittenMessage: action.payload.lastWrittenMessage,
                    unreadMessageCount: 1,
                    customerNumber: destination,
                    productName:action.payload.productName

                }
                newList.push(chatObj);

                return {
                    ...state,
                    chatList: newList
                };

            } else {
                // Mevcut sohbet varsa son mesaj tarih ve saatini güncelle
                newList[numberIndex].lastMessageDate = data.messageDate || newList[numberIndex].lastMessageDate;
                newList[numberIndex].lastMessageTime = data.messageTime || newList[numberIndex].lastMessageTime;
                newList[numberIndex].lastWrittenMessage = action.payload.lastWrittenMessage;
                
                return {
                    ...state,
                    chatList: newList
                }
            }

        case actionTypes.ON_CUSTOMER_SERVICE_LISTENER:
            const newCustomer = action.payload;
            if (!state.chatList.find(c => c.customerNumber === newCustomer.customerNumber)) {
                return {
                    ...state,
                    chatList: [newCustomer, ...state.chatList]
                };
            }
            return state;

        case actionTypes.SELECT_CHAT_FILTER_OPTIONS_SUCCESS:
            return {
                ...state,
                filterOptions: action.payload,
                filterOptionsLoading: false,
                filterOptionsError: false,
                filterOptionsErrorMessage: ""
            };

        case actionTypes.SELECT_CHAT_FILTER_OPTIONS_LOADING:
            return {
                ...state,
                filterOptionsLoading: action.isLoading
            };

        case actionTypes.SELECT_CHAT_FILTER_OPTIONS_ERROR:
            return {
                ...state,
                filterOptionsError: action.hasError,
                filterOptionsErrorMessage: action.errorMessage,
                filterOptionsLoading: false
            };

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_SUCCESS:
            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                newList[index].activityId = action.activityId;
                newList[index].activityName = action.activityName;
            }

            return {
                ...state,
                chatList: newList
            };

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_LOADING:
            return {
                ...state,
                // Could add loading state here if needed for UI feedback
            };

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_ERROR:
            return {
                ...state,
                // Could add error handling here if needed
            };

        case actionTypes.START_MANUAL_CHAT_SUCCESS:
            var updatedList = JSON.parse(JSON.stringify(state.chatList));
            var chatIndex = updatedList.findIndex(w => w.customerNumber == action.customerNumber);
            
            if (chatIndex != -1) {
                updatedList[chatIndex].isAdminTransaction = true;
                updatedList[chatIndex].isOpenTransaction = true;
            }
            
            return {
                ...state,
                chatList: updatedList,
            };

        case actionTypes.START_MANUAL_CHAT_LOADING:
            return {
                ...state,
                // Could add loading state here if needed for UI feedback
            };

        case actionTypes.START_MANUAL_CHAT_ERROR:
            return {
                ...state,
                // Could add error handling here if needed
            };

        case actionTypes.UPDATE_CHAT_ITEM_STATUS:
            var newList = JSON.parse(JSON.stringify(state.chatList));
            var index = newList.findIndex(w => w.customerNumber == action.customerNumber);

            if (index != -1) {
                // Sadece undefined olmayan değerleri güncelle (mevcut değerleri koru)
                if (action.isOpenTransaction !== undefined) {
                    newList[index].isOpenTransaction = action.isOpenTransaction;
                }
                if (action.isOpenAdmin !== undefined) {
                    newList[index].isOpenAdmin = action.isOpenAdmin;
                }
                if (action.activityId !== undefined) {
                    newList[index].activityId = action.activityId;
                }
                if (action.activityName !== undefined) {
                    newList[index].activityName = action.activityName;
                }
            }

            return {
                ...state,
                chatList: newList
            };

        default:
            return state;
    }
}


const chatDetailState = {
    messageList: [],
    isLoading: false,
    hasError: false,
    errorMessage: "",
    customerName: "",
    customerId: "",
    customerImage: "",
    scrollBottomActive: false,
    customerNumber: "",
    isAdminTransaction: false,
    productName:"",
    activityName:"",
    activityId:0,
    isOpenTransaction:false,
    isOpenAdmin:false
};
export function chatDetailReducer(state = chatDetailState, action) {
    switch (action.type) {
        case actionTypes.SELECT_CHAT_DETAIL_LIST_SUCCESS:
            return {
                ...state,
                messageList: action.payload,
                customerName: action.customerName,
                customerId: action.customerId,
                customerImage: action.customerImage,
                customerNumber: action.customerNumber,
                scrollBottomActive: action.payload.length > 0,
                isAdminTransaction: action.isAdminTransaction,
                productName:action.productName,
                activityName:action.activityName,
                activityId:action.activityId,
                isOpenTransaction:action.isOpenTransaction,
                isOpenAdmin:action.isOpenAdmin
            };

        case actionTypes.SELECT_CHAT_DETAIL_LIST_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
                scrollBottomActive: false
            };
        case actionTypes.FINISH_ADMIN_CHAT:
            return {
                ...state,
                isAdminTransaction: false
            };
        case actionTypes.START_ADMIN_CHAT:
            return {
                ...state,
                isAdminTransaction: true
            };

        case actionTypes.SELECT_CHAT_DETAIL_LIST_ERROR:
            return {
                ...state,
                hasError: action.hasError,
                errorMessage: action.errorMessage,
                scrollBottomActive: false
            };

        case actionTypes.ON_CHAT_LISTENER:

            var data = action.payload;
            var destination = data.destination;
            if (destination == state.customerNumber) {
                var defaultList = JSON.parse(JSON.stringify(state.messageList));
                if (!defaultList.find(msg => msg.mainMessageId === data.mainMessageId)) {
                    defaultList.push(data);
                }

                if (global.chatBodyRef) {
                    setTimeout(() => {
                        global.chatBodyRef.scrollToBottom()
                    }, 250);
                }
                return {
                    ...state,
                    messageList: defaultList,
                };

            } else {
                return {
                    ...state,
                }
            }

        case actionTypes.CHANGE_CONVERSATION_ACTIVITY_STATUS_SUCCESS:
            // Chat detail reducer'da da aktivite ID'sini güncelle
            if (state.customerNumber === action.customerNumber) {
                return {
                    ...state,
                    activityId: action.activityId,
                    activityName: action.activityName
                };
            }
            return state;

        default:
            return state;
    }
}